/**
 * String.prototype.replaceAll polyfill — v1 semantics verbatim
 * (index.js:50-54; research/01 §1.2, Q16). Installed from inside the DOM-ready
 * handler, NOT at parse time, and only when the native method is missing.
 *
 * [BUG-PARITY] The match is treated as a REGEX pattern (unescaped), and the
 * `() => replace` thunk suppresses $-pattern expansion.
 */
export function installReplaceAllPolyfill(): void {
  if (typeof (String.prototype as any).replaceAll === "undefined") {
    (String.prototype as any).replaceAll = function (match: any, replace: any) {
      return this.replace(new RegExp(match, "g"), () => replace);
    };
  }
}
